import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import StorefrontAPI from 'utilities/storefrontApi';
import useBrandManifestAndTitle from './useBrandManifestAndTitle';

/**
 * Resolve the brand for the current storefront page.
 *
 * Two modes:
 *   - `/site/:brandRef/...`  — brandRef from the URL
 *   - custom domain          — backend resolves brand from Host header
 *
 * Side effect: installs the per-brand manifest + favicon + page title
 * via `useBrandManifestAndTitle`. Returns `{ brand, error }`, both null
 * while loading.
 */
export default function useBrand() {
  const { brandRef } = useParams();
  const [brand, setBrand] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    setError(null);
    StorefrontAPI.getStorefrontInfo(brandRef)
      .then(setBrand)
      .catch((e) => setError(e?.message || 'Brand not found'));
  }, [brandRef]);
  useBrandManifestAndTitle(brand);
  return { brand, error };
}
